/**
 * Utility functions for the reading feature.
 */

/**
 * Clean a SurrealDB record ID by removing the table prefix.
 * 
 * SurrealDB IDs come in the format "table:id" (e.g., "note:abc123").
 * This function extracts just the ID portion.
 * 
 * @param id - The record ID, potentially with table prefix
 * @returns The clean ID without table prefix
 * 
 * @example
 * cleanRecordId("note:abc123") // "abc123"
 * cleanRecordId("abc123") // "abc123"
 */
export function cleanRecordId(id: string): string {
  return id.includes(":") ? id.split(":")[1] : id;
}
